export function checkNull(value) {
  return (
    value === undefined ||
    value === null ||
    value === '' ||
    value === 'null' ||
    value?.length === 0
  )
}
